import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router';

import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import ResetPassword from 'screens/components/ResetPassword';
import * as resetPasswordService from 'services/resetPasswordService';

const ResetPasswordContainer = () => {
  const [isLoading, setLoading] = useState(false);
  const toast = useToast();
  const { t } = useStoreTranslation();
  const history = useHistory();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const token = params.get('token') ?? '';
  const companyId = params.get('companyId') ?? '';

  const handleSubmit = async (password: string) => {
    if (!token || !companyId) {
      toast.add({ type: 'danger', message: t('resetPassword.invalidLink') });
      return;
    }

    setLoading(true);
    try {
      await resetPasswordService.handleResetPassword(token, companyId, password);
      toast.add({ type: 'success', message: t('resetPassword.successMessage') });
      history.push('/corporate/login/sso');
    } catch (error) {
      toast.add({ type: 'danger', message: t('resetPassword.errorMessage') });
    } finally {
      setLoading(false);
    }
  };

  return <ResetPassword loading={isLoading} onSubmit={handleSubmit} />;
};

export default ResetPasswordContainer;
